import { Playground, Props } from 'docz';
import { Checkbox, CheckboxGroup } from '@madup-inc/mad-design';
import * as React from 'react';
export default {
  Playground,
  Props,
  Checkbox,
  CheckboxGroup,
  React
};